import React, { useCallback } from 'react';
import { IconBtn, UiSelect } from '@ru-digital-assets/ui-component';
import { EditIcon, NoPluginIcon, ArrowLeft } from 'assets/icons';
import { SignFunction } from 'constants/app';
import { useSign } from 'hooks';
import './sign-footer.scss';

interface IFooter {
  onBackButtonClick?: () => void;
  backButtonText?: string;
  signButtonText?: string;
  onSign: (signFunc: SignFunction) => void;
  showBackArrow?: boolean;
  signButtonDisabled?: boolean;
}

export default function SignFooter({
  onBackButtonClick,
  onSign,
  showBackArrow = true,
  backButtonText = 'Вернуться',
  signButtonText = 'Подписать',
  signButtonDisabled = false,
}: IFooter) {
  const {
    certificatesList,
    selectedCertificate,
    signEntity,
    onUserSelectCertificate,
    isSystemError,
  } = useSign();

  const onSignClick = useCallback(() => onSign(signEntity), [
    signEntity,
    onSign,
  ]);

  return (
    <div
      className="sign-footer"
      style={{
        justifyContent: onBackButtonClick ? 'space-between' : 'flex-end',
      }}
    >
      {isSystemError ? (
        <div className="sign-footer__no-plugin">
          <NoPluginIcon />
          <p className="p ml_10 p_color_white">
            Внимание, нет плагина! Для работы на Платформе требуется{' '}
            <a
              className="p p_color_white"
              href="https://cpdn.cryptopro.ru/content/cades/plugin-installation-windows.html"
              target="_blank"
              rel="noreferrer"
            >
              усиленная цифровая подпись (УКЭП).
            </a>
          </p>
        </div>
      ) : (
        <>
          {onBackButtonClick && (
            <span
              onClick={onBackButtonClick}
              className="sign-footer__back-button"
            >
              {showBackArrow && <ArrowLeft />}
              {backButtonText}
            </span>
          )}
          <div className="sign-footer__controls">
            <UiSelect
              placeholder="Выберите сертификат цифровой подписи"
              value={selectedCertificate}
              options={certificatesList}
              lg
              onChange={onUserSelectCertificate}
              disabled={certificatesList.length === 0}
            />
            <div className="sign-footer__sign-button">
              <IconBtn
                title={signButtonText}
                disabled={!selectedCertificate?.value || signButtonDisabled}
                icon={<EditIcon color="#fff" />}
                onClick={onSignClick}
              />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
